/**
 * Report labels, borrowed from TITAN_dev's issue reporting
 * (src/pages/Issues/issueStyles.ts) so a report filed here carries the same
 * vocabulary as one filed there.
 *
 * The colours are TITAN's. Each chip shows its name as text, so the colour
 * is reinforcement and never the only thing identifying a label.
 */
export interface IssueLabel {
    name: string;
    color: string;
    description: string;
}

export const issueLabels: IssueLabel[] = [
    {name: 'bug', color: '#B60205', description: "Something isn't working"},
    {name: 'enhancement', color: '#2a78d6', description: 'New feature or request'},
    {name: 'help wanted', color: '#008672', description: 'Extra attention is needed'},
    {name: 'question', color: '#D876E3', description: 'Further information is requested'},
    {name: 'invalid', color: '#7057FF', description: 'This does not seem right'},
];
